import React from "react";
import { getTTPCapability } from "../../utils/tapToPay";

/* Contactless symbol per Apple requirement 5.5 — visual equivalent of the
   SF Symbol wave.3.right.circle (waves radiating right inside a circle). */
export const TapToPayGlyph = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"
    strokeLinecap="round" className={className} aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <path d="M7.8 10.2a4.6 4.6 0 0 1 0 3.6" />
    <path d="M10.9 8.6a8 8 0 0 1 0 6.8" />
    <path d="M14 7a11.5 11.5 0 0 1 0 10" />
  </svg>
);

/* Apple-required button copy: "Tap to Pay on iPhone" on iOS (per Apple's
   localization strings), "Tap to Pay" elsewhere. */
export const ttpLabel = () => {
  const platform = getTTPCapability().platform;
  if (platform === "ios") return "Tap to Pay on iPhone";
  return "Tap to Pay";
};

export default function TapToPayButton({ onClick, disabled, className = "", dataTestId, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`w-full flex items-center justify-center gap-2 h-12 rounded-xl bg-sky-600 hover:bg-sky-700 disabled:opacity-60 text-white font-semibold text-sm transition-colors ${className}`}
      data-testid={dataTestId || "tap-to-pay-btn"}
    >
      <TapToPayGlyph className="w-5 h-5" />
      {children || ttpLabel()}
    </button>
  );
}
